import {
  LOGOUT, GET_VIOLATIONS, SEARCH_VIOLATIONS, GET_SETTINGS, UPDATE_SETTINGS, SET_VIOLATIONS, SET_SEARCH_RESULTS,
  GET_COMMENTS, GET_HISTORY, GET_ACTIONS, GET_VIOLATION_TERMS, HAS_HISTORY, SEARCH_VIOLATION_FILTERS, SET_FLAG, UPDATE_VIOLATION
} from '../types'

const initialState = {
  violations: {
    captures: [],
    hits: 0,
    flags: [],
    limitedResults: false
  },
  searchResults: {},
  initialListLoaded: false,
  comments: [],
  history: [],
  hasHistory: false,
  actions: [],
  violationTerms: [],
  filterSearch: {
    username: [],
    workstationName: []
  }
}

export default function (state = initialState, action) {
  switch (action.type) {
    case GET_VIOLATIONS:
      // if we're on prem, add the hostname in front of each violation image path
      if ((process.env.REACT_APP_ON_PREM === true || process.env.REACT_APP_ON_PREM === 'true')) {
        action.payload.captures.forEach((capture) => {
          if (window.location.protocol === 'http') {
            capture.signedUrl = 'http://' + window.location.hostname + '/' + capture.signedUrl
          } else {
            capture.signedUrl = 'https://' + window.location.hostname + '/' + capture.signedUrl
          }
        })
      }
      return {
        ...state,
        searchResults: {},
        violations: action.payload
      }
    case SEARCH_VIOLATIONS: return {
      ...state,
      searchResults: action.payload
    }
    case SEARCH_VIOLATION_FILTERS: return {
      ...state,
      filterSearch: action.payload.type === 'username'
        ? { username: action.payload.suggestions, workstationName: [] }
        : { workstationName: action.payload.suggestions, username: [] }
    }
    // These are necessary because all active components receive all dispatch actions
    // Since these actions only pertain to settings, we just return the state
    case GET_SETTINGS: return {
      ...state
    }
    case UPDATE_SETTINGS: return {
      ...state
    }
    case LOGOUT: return {
      ...state,
      ...initialState
    }
    case SET_VIOLATIONS: return {
      ...state,
      violations: {
        ...state.violations,
        captures: action.payload.captures,
        hits: state.violations.hits
      }
    }
    case GET_COMMENTS: return {
      ...state,
      comments: action.payload
    }
    case GET_HISTORY: return {
      ...state,
      history: action.payload
    }
    case HAS_HISTORY: return {
      ...state,
      hasHistory: action.payload
    }
    case GET_ACTIONS: return {
      ...state,
      actions: action.payload
    }
    case GET_VIOLATION_TERMS: return {
      ...state,
      violationTerms: action.payload
    }
    case SET_FLAG: return {
      ...state,
      violations: {
        ...state.violations,
        flags: action.payload
      }
    }
    case UPDATE_VIOLATION: return {
      ...state,
      violations: {
        ...state.violations,
        captures: action.payload
      }
    }
    case SET_SEARCH_RESULTS: return {
      ...state,
      searchResults: action.payload
    }
    default:
      return { ...state }
  }
}
